export default {
    RecACE:"RecACE",
    FIRSTRec:"FIRSTRec",
    Partner: "パートナー管理",
    User: "ユーザー管理",
    Permission:"権限管理",
    Device:"デバイス管理",
    Record:"録音音声一覧",
    Account:"アカウント管理",
    RecACEPlus:"RecACEplus設定",
    RecViewer:"RecViewer設定",
    Category:"通話分類設定",
    ProperNoun:"固有名詞設定",
    PhoneBook: "要約詳細管理",
    VocHistory: "VoC分析作成履歴",
    VocCategory: "VoCカテゴリー設定",
    AlarmSetting: "アラーム設定",
    NotificationSetting: "外部通知設定",
    MailSetting: "メール送信設定",
    ManualSetting: "RecACE設置マニュアル.pdf",
    ManualPlusUser: "RecACEplus利用マニュアル.pdf",
    ManualPlusUserWeb: "RecACEplus利用マニュアル(WEB版).pdf",
}